import connect from './connect';

export { NotificationsScreen } from './NotificationsScreen';

export default connect;
